import { Container } from "@components/wrapper"
import { SchoolDetail } from "@interfaces/school"
import clsx from "clsx"
import React from "react"
import { BootcampHeading } from "../general/ProgramHeading"

export interface Props {
  schoolDetail: SchoolDetail
}

export const BootcampOutcomes = ({ schoolDetail }: Props) => {
  const OUTCOMES = [
    {
      title: `${schoolDetail.total_alumni}+`,
      description: "Alumni telah bekerja di perusahaan top",
    },
    {
      title: "99,98%",
      description: "99.98% sudah bekerja. Hanya 0.02% masih mencari.",
    },
    {
      title: "Rp4-10 Juta",
      description: "Rentang gaji yang alumni dapatkan",
    },
    {
      title: "< 3 Bulan",
      description: "Rata-rata waktu alumni dapat pekerjaan setelah lulus",
    },
  ]

  return (
    <div className="bg-[#CADCFF]">
      <Container className={clsx("relative", "sm:pt-20 sm:pb-10 pt-10 pb-5")}>
        <BootcampHeading
          id="outcomes"
          title="outcomes"
          subTitle="Yang Kami Telah Capai Dalam 2,5 Tahun"
        />

        <div className={clsx("sm:flex sm:gap-9 sm:my-9 sm:mb-9", "grid mt-6 mb-4 gap-4")}>
          {OUTCOMES.map((out, idx) => (
            <div
              key={idx}
              className={clsx("card-box bg-white grid gap-1 rounded-10", "sm:w-1/4 sm:p-6 p-4")}
            >
              <div className="font-urbanist text-new-blue sm:text-[32px] text-2xl font-bold ">
                {out.title}
              </div>
              <div className="text-primary-black sm-only:text-xs">{out.description}</div>
            </div>
          ))}
        </div>

        <div className="sm-only:text-sm text-black-48">Update Terakhir: Januari 2024</div>
      </Container>
    </div>
  )
}
